export default {
    header: {
        language: '语言',
        zh: '简体中文',
        en: '英文',
        logOut: '登出',

    },
    common: {
        cancel: '取消',
        confirm: '确定',
        search: '查询',
        exportExcel: '导出 Excel',
        add: '新增',
        edit: '编辑',
        delete: '删除',
        select: '请选择',
        actions: '操作',
        view: '查看',
        choose:{
            yes: '是',
            no: '否'
        }
    },
    tags: {
        options: '标签选项',
        closeOthers: '关闭其他',
        closeAll: '关闭所有'
    },
    menu: {
        home: '首页',
        permission: '权限',
        permissionManage: '权限管理',
        roleManage: '角色管理',
        userManage: '用户管理',
        cost: '费用',
        companyCost: '公司费用',
        fixedCost: '固定费用',
        specialFee: '特殊收费标准',
        feeStandard: '收费标准',
        storedValue: '储值记录',
        order: '订单',
        addOrder: '新增订单',
        orderManage: '订单管理',
        accountManage: '账号管理',
        accountInfo: '账号信息',
        userAddress: '用户地址管理',
        noticeManage: '公告管理',
        discountApply: '折扣申请',
        orderDetail: '订单详情',
        invoiceManage: '开票管理',
        invoiceTitleManage: '抬头管理',
        SupplierOrderManager: '订单管理(供应商)',
        FeesDataShow: '费用数据展示',
        OtherChargeStandard: '其他费用收费标准',
        changePassword: '修改密码',
        authGroupManage: '权限组管理'
    },
    home: {
        welcome: '欢迎使用抱抱国际物流管理平台',
        subtitle: '实时监控您的物流数据和订单状态',
        balanceAvailable: '用户账户内可用余额总额',
        balanceWarning1: '账期订单到期以及现金订单会扣除余额，扣除失败将会逾期，逾期将不能创建订单',
        creditLimit: '用户信用额度上限',
        creditWarning1: '创建账期订单时需满足：',
        creditWarning2: '可用余额 + 信用额度 > 账期总额 + 未完成订单总额',
        billAmount: '账期总额',
        unfinishedOrderAmount: '未完成订单总额',
        announcement: '公告',
        updatedAt: ' 更新'
    },
    specialFee: {
        add: '新增',
        id: 'ID',
        name: '收费标准名称',
        price: '费用金额',
        description: '费用描述',
        addDialogTitle: '新增特殊收费标准',
        editDialogTitle: '更新特殊收费标准',
        namePlaceholder: '请输入收费标准名称',
        pricePlaceholder: '请输入费用金额',
        descriptionPlaceholder: '请输入费用描述'
    },
    chargeStandard: {
        payType: '支付方式',
        deliveryType: '卸货方式',
        address: '地址',
        addressPlaceholder: '请输入地址',
        price: '价格($)',
        pricePlaceholder: '请输入价格',
        description: '描述',
        descriptionPlaceholder: '请输入描述',
        start: '创建时间',
        end: '更新时间',
        range: '查询范围',
        addDialog: '新增收费标准',
        editDialog: '更新收费标准',
        select: '请选择',
        currentStandards: '当前收费标准',
        allStandards: '所有收费标准',
        extraFeeTips: `其他费用（这些费用会在订单过程中收取并展示，此处仅展示美西部分，其他地区请联系客服）：\n
固定费用(Pier Pass + CTF)：20尺 ： $50.00    40/45尺 ： $100.00 部分地区可能会有所差异\n
车架：40$/day（部分地区包车架费用，详情联系客服） 特殊车架除外\n`
    },
    balance: {
        userId: '用户ID',
        description: '描述',
        type: '储值类型',
        number: '储值金额($)',
        image: '图片',
        payType: '扣款周期(订单结算时使用)',
        createTime: '创建时间',
        operation: '操作',
        startTime: '开始时间',
        endTime: '结束时间',
        uploadRecord: '上传充值记录',
        exportBill: '导出账单',
        viewAccount: '查看收款账户',
        openInvoice: '开票',
        uploadImage: '上传图片',
        edit: '编辑',
        addTitle: '新增储值',
        editTitle: '更新储值',
        clientId: '客户Id',
        currency: '币种',
        amount: '金额($)',
        paymentMethod: '支付方式',
        upload: '上传',
        view: '查看',
        deleteConfirm: '确定删除文件？',
        uploadImageDialog: '上传图片',
        viewImage: '查看图片',
        currentRate: '当前汇率：',
        account: '账户',
        usAccount: '美国账户（U.S. Account）',
        cnAccount: '中国账户（Mainland China Account）',
        company: '公司名 (Company)',
        bank: '银行 (Bank)',
        address: '地址 (Address)',
        swift: 'SWIFT Code',
        ach: 'ACH Routing#',
        wires: 'Wires RT#',
        accountNumber: '账户号码 (Account#)',
        paymentTip: '💡 请根据您的付款地区选择对应账户进行汇款。',
        zhNumber:'储值金额(￥)',
        status: {
            "-2": "失败",
            "-1": "提交待审核",
            "0": "充值-待入账",
            "1": "消费-信用",
            "2": "到账",
            "3": "消费",
            "4": "退款",
            "undefined":""
        }
    },
    order: {
        baseInfoTip: '基础信息（填写完成后会自动给出价格，若找不到送货地址或填写完后价格为空，请先联系客服）',
        userId: '用户ID',
        inputUserId: '请输入用户ID',
        address: '送货地址',
        manageAddress: '管理地址',
        dischargeType: '卸货方式',
        payType: '支付方式',
        size: '货物尺寸',
        thing: '集装箱物品',
        inputThing: '请输入物品',
        specialType: '特殊类型',
        doInfo: 'DO信息（可后续补充）',
        terminal: '码头',
        shippingCompany: '船公司',
        cabinetNumber: '柜号',
        inputCabinetNumber: '请输入柜号',
        mbl: '提单号',
        inputMbl: '请输入提单号',
        estimatedArrival: '预计到达时间',
        selectDate: '选择时间',
        remarks: '备注',
        inputRemarks: '请输入备注',
        price: '价格：',
        basicFee: '基础费用',
        specialFee: '特殊费用',
        ppCtf20: 'pp + ctf：50$',
        ppCtf40: 'pp + ctf：100$',
        viewSpecialFee: '查看特殊收费标准',
        total: '总价格：',
        priceNote: '基础价格不包含超时、存储费等费用',
        viewChargeStandard: '查看收费标准',
        submit: '提交',
    },
    orderDetail: {
        orderEvents: '订单事件',
        orderFees: '订单费用',
        internalEvent: '内部事件',
        orderStatus: '订单状态',
        eventType: {
            消息事件: '消息事件',
            异常事件: '异常事件'
        },
        feeStatus: '订单费用产生状态',
        feeAmount: '订单费用',
        image: '图片',
        view: '查看',
        detail: '详情',
        viewImage: '查看图片'
    },
    orderStatus: {
        "100": "订单创建",
        "200": "等待DO录入",
        "300": "信息核对",
        "400": "运输中",
        "500": "到港",
        "600": "约柜完成",
        "700": "即将提柜",
        "800": "提柜中",
        "900": "提柜完成",
        "1000": "等待送仓",
        "1100": "送仓完成",
        "1200": "待还空",
        "1300": "约还空完成",
        "1400": "还空中",
        "1500": "还空成功",
        "1600": "完成"
    },
    userInfo: {
        title: '用户信息',
        subtitle: '管理您的个人信息',
        personalInfo: '个人信息',
        oldPassword: '旧密码',
        newPassword: '新密码',
        confirmPassword: '确认新密码',
        inputOldPassword: '请输入旧密码',
        inputNewPassword: '请输入新密码',
        inputConfirmPassword: '请再次输入新密码',
        changePassword: '修改密码',
        backToProfile: '返回个人信息',
        passwordHint: '请填写旧密码，并输入两次一致的新密码。',
        passwordMismatch: '两次输入的新密码不一致',
        passwordValidation: '请填写旧密码、新密码和确认密码，且两次新密码必须一致',
        nameRequired: '姓名不能为空',
        updateSuccess: '修改成功',
        updateFailed: '修改失败，请重试',
        id: 'ID',
        name: '姓名',
        password: '密码',
        email: '邮箱',
        address: '地址',
        inputName: '请输入姓名',
        inputPassword: '请输入密码',
        inputEmail: '请输入邮箱',
        inputAddress: '请输入地址',
        submit: '提交修改'
    },
    address: {
        subtitle: '管理您的收货地址信息',
        tableTitle: '地址列表',
        userId: '用户ID',
        userIdPlaceholder: '请输入用户ID',
        select: '选择地址',
        selectPlaceholder: '请选择送货地址',
        detail: '详细地址',
        detailPlaceholder: '请输入地址',
        standard: '收费标准地址',
        addTitle: '新增地址',
        editTitle: '更新地址'
    },
    orderManage: {
        createTime: '创建时间',
        displayTitle: '显示标题',
        orderByName: '排序列',
        orderByType: '排序方式',
        payType: '支付方式',
        size: '货物尺寸',
        terminal: '码头',
        shippingCompany: '船运公司',
        status: '订单状态',
        mbl: '提单号',
        cabinetNumber: '柜号',
        id: 'ID',
        userId: '用户ID',
        timeType: '时间类型',
        startTime: '开始时间',
        endTime: '结束时间',
        todayOrder: '查看今日订单',
        clear: '清空',
        viewDetails: '查看详情',
        viewEvents: '查看事件',
        viewCharges: '查看收费',
        fillDO: '填写DO信息',
        updateStatus: '状态更新',
        completeOrder: '完成订单',
        statusButtonLabel: {
            500: '到港待约柜',
            600: '约柜完成',
            700: '明日提柜',
            800: '提柜中',
            1000: '送仓中',
            1100: '送仓完成',
            1200: '待还空',
            1300: '约还空完成'
        },
        statusUpdate: '状态更新',
        editTitle: '编辑订单',
        statusId: '订单状态',
        dischargeType: '卸货方式',
        specialType: '特殊类型',
        basicFee: '基础费用',
        thing: '物品',
        address: '送货地址',
        estimatedTimeArrival: '预计到达时间',
        lastFreeDay: '最后免费存放时间/LFD',
        appointmentTime: '预约提柜时间',
        reservationDeliveryTime: '预约送仓时间',
        chassis: '架子号码',
        enterDockTime: '进码头时间',
        leaveDockTime: '离码头时间',
        lastPerdiemTime: '最迟还空时间',
        currentLocation: '当前柜子所在位置',
        startDeliveryTime: '开始送仓时间',
        finishDeliveryTime: '完成送仓时间',
        emptyReadyTime: '报空时间',
        emptyReservationTime: '还空预约时间',
        returnTerminal: '还空码头',
        emptyGetTime: '提空时间',
        emptyReturnTime: '还空时间',
        sendDriverId: '送仓司机ID',
        returnDriverId: '收仓司机ID',
        remark: '订单备注',
        listTitle: '事件列表',
        add: '添加事件',
        edit: '编辑事件',
        type: '事件类型',
        typePlaceholder: '请选择事件类型',
        time: '发生时间',
        selectTime: '选择日期时间',
        statusPlaceholder: '订单状态',
        image: '图片',
        confirmDelete: '确定删除文件？',
        description: '事件详情',
        descriptionPlaceholder: '请输入事件详情',
        handle: '处理结果',
        handlePlaceholder: '请输入处理结果',
        upload: '上传图片',
        feeList: '费用列表',
        addFee: '添加费用',
        editFee: '编辑费用',
        submitTime: '提交时间',
        amount: '费用（$）',
        descriptionFee: '费用详情',
        statusWhenGenerated: '产生费用时状态',
        uploadImg: '上传图片',
        confirmDeleteFile: '确定删除文件？',
        view: '查看',
        amountPlaceholder: '请输入费用',
        descriptionPlaceholderFee: '请输入费用详情',
        statusPlaceholderFee: '请选择费用状态',
        viewImage: '查看图片',
        remarks: '备注',
        specialTypeIds: '特殊类型',
        next: '是否去向下一步',
        location:{
            "运输" : "运输",
            "暂存车场": "暂存车场",
        },
        orderByLabel: {
            create_time: "创建时间",
            status_id: "订单状态",
            desc: "降序",
            asc: "升序"
        },
        cargoSize: {
            20: "20尺",
            40: "40尺",
            45: "45尺"
        },
        orderFieldLabel: {
            userId: "用户id",
            id: "订单id",
            statusId: "订单状态",
            payType: "支付类型",
            dischargeType: "卸货方式",
            specialTypeChoose: "特殊类型",
            basicFee: "基础费用（$）",
            thing: "物品",
            mbl: "提单号",
            cabinetNumber: "柜号",
            size: "货物尺寸（英寸）",
            shippingCompany: "船运公司",
            terminal: "码头",
            address: "送货地址",
            estimatedTimeArrival: "预计到达时间",
            lastFreeDay: "最后免费存放时间/LFD",
            appointmentTime: "预约提柜时间",
            reservationDeliveryTime: "预约送仓时间",
            chassis: "架子号码",
            enterDockTime: "进码头时间",
            leaveDockTime: "离码头时间",
            lastPerdiemTime: "最迟还空时间",
            currentLocation: "当前柜子所在位置",
            startDeliveryTime: "进码头时间",
            finishDeliveryTime: "离码头时间",
            emptyReadyTime: "报空时间",
            emptyReservationTime: "还空预约时间",
            returnTerminal: "还空码头",
            emptyGetTime: "提空时间",
            emptyReturnTime: "还空时间",
            sendDriverId: "送仓司机id",
            returnDriverId: "收仓司机id",
            remark: "订单备注",
            createTime: "创建时间",
        }
    },
    login: {
        systemName: '抱抱国际物流',
        welcomeMessage: '欢迎使用抱抱国际物流管理平台',
        usernamePlaceholder: '请输入账号',
        passwordPlaceholder: '请输入密码',
        login: '登录',
        disclaimerPrefix: '我已阅读并同意',
        disclaimerConsent: '我已阅读并同意免责及理赔条款',
        disclaimerRequired: '请先阅读并同意《免责及理赔条款》',
        closeDisclaimer: '关闭',
        acceptDisclaimer: '我已阅读并同意',
        register: '注册',
        forgotPassword: '忘记密码？',
        verifyType: '验证方式',
        phone: '手机号',
        email: '邮箱',
        phonePlaceholder: '请输入手机号',
        emailPlaceholder: '请输入邮箱',
        codePlaceholder: '请输入验证码',
        getCode: '获取验证码',
        retryLater: '后重试',
        newPasswordPlaceholder: '请输入新密码',
        submit: '提交',
        backToLogin: '返回登录',
        resetPassword: '重置密码',
        resetPasswordDesc: '请选择验证方式并输入相关信息'
    },
    register: {
        systemName: '抱抱国际物流',
        welcomeMessage: '欢迎注册抱抱国际物流管理平台',
        verifyType: '验证方式',
        accountPlaceholder: '请输入账号',
        nicknamePlaceholder: '请输入姓名',
        passwordPlaceholder: '请输入密码',
        password2Placeholder: '请再次输入密码',
        email: '邮箱',
        phone: '手机号',
        emailVerifyPlaceholder: '请输入验证邮箱',
        phoneVerifyPlaceholder: '请输入+86的手机号码进行验证',
        sendCode: '发送验证码',
        retrySeconds: ' 秒后可再次发送',
        codePlaceholder: '请输入验证码',
        emailContactPlaceholder: '请输入联系邮箱',
        phoneContactPlaceholder: '请输入联系手机号',
        addressPlaceholder: '地址',
        licenseCodePlaceholder: '营业执照编号',
        uploadLicense: '上传营业执照照片（图片或pdf）',
        chooseFile: '选择文件',
        uploadTip: '支持 JPG、JPEG、PNG、PDF 格式，文件大小不超过 10MB',
        uploadedFile: '已上传文件',
        toLogin: '返回登录',
        register: '注册'
    }

}
